import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  isSelected?: boolean
}

export default createStyles((theme, params: StylesParams) => {
  const { isSelected } = params
  return {
    root: {
      position: 'relative',
      color: '#262626',
      transition: 'all .2s ease',
      padding: '8px 0',
      ...(isSelected && {
        cursor: 'default',
      }),
      '&:hover, &.selected': {
        color: theme.fn.primaryColor(),
        '&:before': {
          width: 30,
        },
      },
      '&:before': {
        content: '""',
        borderBottom: `1px solid ${theme.fn.primaryColor()}`,
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translate(-50%, 0)',
        transition: 'all .3s ease',
        width: 0,
      },
    },
    title: {
      lineHeight: rem(22),
      fontSize: 14,
    },
  }
})
